import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import InternalModalWrapper from './internal/components/modal-wrapper';
export default function ModalWrapper(props) {
  // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
  return /*#__PURE__*/React.createElement(InternalModalWrapper, _extends({}, props, {
    isFullScreen: false
  }));
}